"use client";
import * as React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export default function ImageZoom({
  src,
  alt,
  open,
  onOpenChange,
  maxWidth = 1200,
}: {
  src?: string | null;
  alt?: string | null;
  open: boolean;
  onOpenChange: (o: boolean) => void;
  maxWidth?: number;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="p-0" style={{ maxWidth }}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        {src ? (
          <img src={src} alt={alt || "Image"} className="w-full h-auto block" />
        ) : (
          <div className="p-6 text-sm text-muted-foreground">No image</div>
        )}
      </DialogContent>
    </Dialog>
  );
}

